export default {"src":"/_next/static/media/calendar-plus.7d6f1c2f.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};